<script setup lang="ts">
  import type { UserTagType } from "~/entities/UserTagType";
  import { useDeliveryStore } from "~/stores/DeliveryStore";
  import { useTagStore } from "~/stores/TagStore";

  defineProps<{
    type: string[]; // price/ plan / individual
  }>();

  const localTagTypes = ref<UserTagType[]>([]);

  const emit = defineEmits<{
    (e: "onConfirm", value: UserTagType[]): void;
  }>();

  const modal = ref(false);

  const useTag = useTagStore();
  const deliveryStore = useDeliveryStore();

  const openModal = async (value: UserTagType[], options: Record<string, string>) => {
    await deliveryStore.getAccountPlans();
    await useTag.fetchUserTagTypes(options);
    localTagTypes.value = value;
    modal.value = true;
  };

  const getTagTypes = (type: string) => {
    return useTag.userTagTypes?.userTagTypes.filter(val => val.userTagCategory === type) || [];
  };

  const handleUpdate = (val: UserTagType[], type: string) => {
    const newTagTypes = localTagTypes.value.filter(tag => tag.userTagCategory !== type);
    localTagTypes.value = [...newTagTypes, ...val];
  };

  const handleFilter = () => {
    modal.value = false;
    emit("onConfirm", localTagTypes.value);
  };

  defineExpose({
    openModal,
  });

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
</script>

<template>
  <v-dialog v-model="modal" :max-width="isSp ? 400 : 600" scrim="black" scrollable>
    <v-card class="d-flex flex-column justify-center px-4 py-8 dialog-body" data-testid="member-tag-filter-dialog">
      <div class="text-left font-weight-bold mb-2">
        <v-icon icon="$mdiTag" color="white" size="20" />
        タグを選択
      </div>
      <v-divider></v-divider>

      <div class="condition-frame">
        <div class="d-flex ga-4 mt-4" :class="{ 'flex-column': isSp }">
          <div>
            <MoleculesDeliveryConditionInfoTagSelector
              v-if="type.includes('plan')"
              title=" + 講座タグ"
              :user-tag-types="getTagTypes('講座')"
              :value="localTagTypes"
              @update:value="val => handleUpdate(val, '講座')"
            />
            <MoleculesDeliveryConditionInfoTagSelector
              v-if="type.includes('price')"
              title=" + プランタグ"
              :user-tag-types="getTagTypes('プラン')"
              :value="localTagTypes"
              @update:value="val => handleUpdate(val, 'プラン')"
            />
            <MoleculesDeliveryConditionInfoTagSelector
              v-if="type.includes('individual')"
              title=" + 個別付与タグ"
              :user-tag-types="getTagTypes('個別')"
              :value="localTagTypes"
              @update:value="val => handleUpdate(val, '個別')"
            />
          </div>
          <MoleculesDeliveryConditionInfoSelectedTags v-model="localTagTypes" />
        </div>
      </div>

      <div class="d-flex ga-4 mt-4">
        <AtomsButton variant="outlined" size="x-large" color="white" @click="modal = false"> キャンセル </AtomsButton>
        <AtomsButton color="blue" size="x-large" @click="handleFilter"> OK </AtomsButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .dialog-body {
    height: 100%;
    color: white;
    background-color: rgba(var(--v-theme-monochrome-04), 0.85);
  }
  .condition-frame {
    max-height: 70vh;
    overflow-y: auto;
    scrollbar-width: none;
  }
</style>
